export const MenuItems = [
  {
    title : "Home",
    url : "/",
    cName : "nav-links",
    icon : "fa fa-home",
  },
  {
    title : "About",
    url : "/",
    cName : "nav-links",
    icon : "fa fa-user",
  },
  {
    title : "Service",
    url : "/",
    cName : "nav-links",
    icon : "fa fa-briefcase",
  },
  {
    title : "Contact",
    url : "",
    cName : "nav-links",
    icon : "fa fa-comment",
  },
  {
    title : "Sign Up",
    url : "/",
    cName : "nav-links-mobile",
  },
]